import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { ActivityService, ActivityStmService } from '@contact/upgrade';

import { ActivityStatusDeprecatedService, default as activityStatusDeprecatedServiceName } from './activity-status-deprecated.service';

export default module('contact.agent.core.activity', [])
  .run([activityStatusDeprecatedServiceName, () => {}])
  .service(activityStatusDeprecatedServiceName, ActivityStatusDeprecatedService)
  // service
  .factory('activityService', downgradeInjectable(ActivityService) as any)
  .factory('activityStatusService', downgradeInjectable(ActivityStmService) as any).name;
